import { MagnifyingGlass } from '@creditornot/cb-icons';
import { Input } from '@creditornot/cb-input';
import React, { ChangeEvent } from 'react';
import { useRef, useEffect } from 'react';

import { SearchWrapper } from './styles';

type Props = {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const SelectorSearch = ({ value, onChange }: Props) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    ref.current !== null && ref.current.focus();
  }, []);

  return (
    <SearchWrapper>
      <Input
        icon={<MagnifyingGlass />}
        placeholder="Search"
        type="text"
        value={value}
        inputRef={ref as any}
        onChange={onChange}
      />
    </SearchWrapper>
  );
};
